import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { RedirectToDjango } from '@saucelabs/sl-container-experiment';

const XTMAdminContainer = ({
  children,
  inExtendedTeamManagement,
  isOrganizationAdmin,
  isTeamAdmin,
}) => {
  if (inExtendedTeamManagement && isOrganizationAdmin) {
    return children[1];
  }

  if (inExtendedTeamManagement && !isOrganizationAdmin && isTeamAdmin) {
    return children[0];
  }

  if (inExtendedTeamManagement && !isOrganizationAdmin) {
    return <Redirect to="/dashboard" />;
  }

  return <Route component={RedirectToDjango} />;
};

XTMAdminContainer.propTypes = {
  children: PropTypes.node.isRequired,
  inExtendedTeamManagement: PropTypes.bool.isRequired,
  isOrganizationAdmin: PropTypes.bool.isRequired,
  isTeamAdmin: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ user }) => ({
  inExtendedTeamManagement: user.get('team_management'),
  isTeamAdmin: user.get('is_team_admin'),
  isOrganizationAdmin: user.get('is_organization_admin'),
});

export default connect(mapStateToProps)(XTMAdminContainer);
export { XTMAdminContainer, mapStateToProps };
